import { ConfirmDialog, Icon } from '@acs/ui';
import { useI18n } from '../../i18n/index.js';

/**
 * "Discard what you typed?" in front of closing a booking form with changes in
 * it (doc 43 D9) — the owner may be typing while the customer is still on the
 * line, and a stray Escape or backdrop click must not cost them the booking.
 */
export function DiscardChangesDialog({ onKeep, onDiscard }: { onKeep(): void; onDiscard(): void }) {
  const { t } = useI18n();
  return (
    <ConfirmDialog
      tone="warning"
      title={t('bookingForm.discardTitle')}
      description={t('bookingForm.discardDetail')}
      icon={<Icon name="alert-triangle" size={24} />}
      confirmLabel={t('common.discard')}
      cancelLabel={t('bookingForm.keepEditing')}
      onCancel={onKeep}
      onConfirm={onDiscard}
    />
  );
}
